import { render, staticRenderFns } from "./GroupModal.vue?vue&type=template&id=fcbb1066"
import script from "./GroupModal.vue?vue&type=script&lang=ts"
export * from "./GroupModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports